export default __webpack_public_path__ + "two-trees-log.png";